// export const BASE_URL = 'http://192.168.1.3:5000';

export const BASE_URL = 'https://leadershipforgodbackend-fsm2.onrender.com';

// email: example@gmail.com
// mot de passe: QdMib&3q
